/** @format */

import Tooltip from '@material-ui/core/Tooltip';
import I18n from '../Translate/I18n';
import Checkbox from '@material-ui/core/Checkbox';
import { Check } from 'mdi-material-ui';
import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';

interface SearchNullProps {
    classes: any;
    fieldName: string;
    fieldType?: string;
    value?: any;
    updateCallback: (param1: any, param2?: any) => void;
}

class SearchNull extends PureComponent<SearchNullProps> {
    updateField = (fieldName: string): void => {
        const { updateCallback, fieldType, value } = this.props;

        const tmpValue = value && value === 'null' ? '' : 'null';

        if (fieldType) {
            switch (fieldType) {
                case 'date':
                    updateCallback(tmpValue, fieldName);
                    break;
                case 'date-simple':
                    updateCallback(tmpValue);
                    break;
                case 'checkbox':
                    updateCallback(true, tmpValue);
                    break;
                default:
                    break;
            }
        } else {
            updateCallback(tmpValue);
        }
    };

    render():
        | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        | string
        | number
        | {}
        | React.ReactNodeArray
        | React.ReactPortal
        | boolean
        | null
        | undefined {
        const { classes, fieldName, value } = this.props;
        return (
            <Tooltip
                title={<I18n trans={'general:common.search_empty'} />}
                id={'tooltip-search-empty-' + fieldName}
                placement={'bottom'}
                classes={{ tooltip: classes.tooltip }}
            >
                <Checkbox
                    onClick={(): void => {
                        if (!fieldName) {
                            return;
                        }
                        this.updateField(fieldName);
                    }}
                    checked={!!(value && value === 'null')}
                    color={'primary'}
                    style={{
                        width: '40px',
                        // left: 0,
                        // position: 'absolute',
                    }}
                />
            </Tooltip>
        );
    }
}

export default compose<any, any>(withStyles(adescomStyle))(SearchNull);
